import { theme } from '@febos-io/design';

import useTranslation from '../hooks/useTranslation';
import { useAuthContext } from '../providers';

export function ResetPasswordPage() {
  const { t } = useTranslation();
  const {
    ResetPasswordForm
  } = useAuthContext();
  return (
    <theme.views.Login>
      <strong>{t('Create Password')}</strong>
      <ResetPasswordForm />
    </theme.views.Login>
  );
}

export default ResetPasswordPage;
